import React from "react";
import PropTypes from "prop-types";
import './style.scss';


//import Loading from 'components/Loading';

const PopupMaterials = ({
    execActionConfirm = null,
    titleText = "",
    popupMaterialText = [],
}) => {

    function doSearch()

    {

        const tableReg = document.getElementById('datos');

        const searchText = document.getElementById('searchTerm').value.toLowerCase();

        let total = 0;



        // Recorremos todas las filas con contenido de la tabla

        for (let i = 1; i < tableReg.rows.length; i++) {

            // Si el td tiene la clase "noSearch" no se busca en su cntenido

            if (tableReg.rows[i].classList.contains("noSearch")) {

                continue;

            }



            let found = false;

            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');

            // Recorremos todas las celdas

            for (let j = 0; j < cellsOfRow.length && !found; j++) {

                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();

                // Buscamos el texto en el contenido de la celda

                if (searchText.length == 0 || compareWith.indexOf(searchText) > -1) {

                    found = true;

                    total++;

                }

            }

            if (found) {

                tableReg.rows[i].style.display = '';

            } else {

                // si no ha encontrado ninguna coincidencia, esconde la

                // fila de la tabla

                tableReg.rows[i].style.display = 'none';

            }

        }



        // mostramos las coincidencias

        const lastTR=tableReg.rows[tableReg.rows.length-1];

        const td=lastTR.querySelector("td");

        lastTR.classList.remove("hide", "red");

        if (searchText == "") {

            lastTR.classList.add("hide");

        } else if (total) {

            td.innerHTML="Se ha encontrado "+total+" coincidencia"+((total>1)?"s":"");

        } else {

            lastTR.classList.add("red");

            td.innerHTML="No se han encontrado coincidencias";

        }

    }



    const handleConfirm = (event) => {
        execActionConfirm && execActionConfirm(event);
    };
    function MaterialList() {
       
        const materials = popupMaterialText;
      
        const lisTable= <div>
        <table className="table" id="datos">
          <thead>
            <tr>
              <th >Productos</th>
              <th>Ean</th>
              <th>Sap</th>
           
            </tr>
          </thead>
          <tbody>
            {materials.map((user) => {
              return (
                <tr key={user.ean}>
                  <td className="td-material ">{user.material}</td>
                  <td  className="td-material">{user.ean}</td>
                  <td className="td-material">{user.sap}</td>
                 
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
   

        return <div>{lisTable}</div>;
    }
     const myComponent = {
        height: "300px",
        overflow: "auto",
        scrollbarColor: "red",
        //background:'red',

        //border:'1px solid silver',
    };

    return (
        
        <div className="white-popup message-popup-simple">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mb-4 red">
                                    <strong>{titleText}</strong>
                                </p>
                                
                                <strong><i className='fas fa-search icon-search' ></i></strong>
                                <input className="search-materiales col" type="search" id="searchTerm"  placeholder="¿Que producto necesitas?" onKeyUp={doSearch} />
                                
                                <div className="text-center mb-4" style={myComponent}>
                                {
                                    MaterialList()
                                 
                                }
                                </div>
                                <div className="text-center">
                                    <a
                                        href="#"
                                        onClick={(event) =>
                                            handleConfirm(event)
                                        }
                                        className="btn"
                                        id="a-confirm"
                                    >
                                        Aceptar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PopupMaterials.propTypes = {
    execActionConfirm: PropTypes.func,
    popupMaterialText: PropTypes.array,
    titleText: PropTypes.string,
};

export default PopupMaterials;
